import { useQuery } from 'react-query';

import { ISelectModel } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getLanguagesFromRoot } from 'services/api/apiCalls/rentals';

const getLanguages = (): Promise<ISelectModel<number>[]> =>
  getLanguagesFromRoot().then(response => response.data);

export const useLanguagesQuery = (enabled?: boolean) =>
  useQuery(
    QUERY_KEYS.RENTALS_LANGUAGES,
    getLanguages,
    { enabled, keepPreviousData: true, staleTime: 5 * 60 * 1000 }, //5 minutes
  );
